var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerSlotAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a0a09f;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "booked_by_partner_slot_iconAsset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.41,3.74a.84.84,0,0,1,.84-.9H7.79a2.57,2.57,0,0,1,2.72,2.71,2.56,2.56,0,0,1-2.72,2.7H6.16v2.1a.86.86,0,0,1-.88.81.87.87,0,0,1-.87-.81Zm1.75.65V6.71H7.71a1.1,1.1,0,0,0,1-1.16,1.09,1.09,0,0,0-1-1.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerSlotAsset);
export default __webpack_public_path__ + "static/media/partner_slot_asset.3b885a72800abf2141eb33e1abbd4eeb.svg";
export { ForwardRef as ReactComponent };